const data = [
  {
    videoUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/v1681003683/tpqzda6yzvycbzim6tic.mp4",

    thumbnailUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/c_limit,h_60,w_90/v1681003683/tpqzda6yzvycbzim6tic.jpg",

    title: "Introduction to Programming & Python - Python Tutorial - Day #1",
    time: "11:49",
  },

  {
    videoUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/v1681003734/hb5xxfmo6k0b54jz2xro.mp4",

    thumbnailUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/c_limit,h_60,w_90/v1681003734/hb5xxfmo6k0b54jz2xro.jpg",

    title:
      "Some Amazing Python Programs - The Power of Python - Python Tutorial - Day #2",
    time: "12:40",
  },

  {
    videoUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/v1681003811/zxtlnvrbk7hu5gapo9ww.mp4",

    thumbnailUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/c_limit,h_60,w_90/v1681003811/zxtlnvrbk7hu5gapo9ww.jpg",

    title: "Modules and Pip - Python Tutorial - Day #3",
    time: "6:49",
  },

  {
    videoUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/v1681003926/tmt61ubpy3ic3gebcmke.mp4",

    thumbnailUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/c_limit,h_60,w_90/v1681003926/tmt61ubpy3ic3gebcmke.jpg",

    title: "Our First Python Program - Python Tutorial - Day #4",
    time: "7:23",
  },

  {
    videoUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/v1681004090/ss6osspvjsxu8qnm4dqj.mp4",

    thumbnailUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/c_limit,h_60,w_90/v1681004090/ss6osspvjsxu8qnm4dqj.jpg",

    title:
      "Comments, Escape Sequences & Print Statement - Python Tutorial - Day #5",
    time: "9:24",
  },

  {
    videoUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/v1681004092/v8hw523e3vzf3bsupfgs.mp4",

    thumbnailUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/c_limit,h_60,w_90/v1681004092/v8hw523e3vzf3bsupfgs.jpg",

    title: "Variables and Data Types - Python Tutorial - Day #6",
    time: "8:37",
  },

  {
    videoUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/v1681004094/nwyyb8u5f2el0sroph7v.mp4",

    thumbnailUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/c_limit,h_60,w_90/v1681004094/nwyyb8u5f2el0sroph7v.jpg",

    title: "Exercise 1- Calculator using Python - Python Tutorial - Day #7",
    time: "11:49",
  },

  {
    videoUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/v1681004095/vuhzrchiifjgdqss2bjo.mp4",

    thumbnailUrl:
      "https://res.cloudinary.com/dkvh16kiu/video/upload/c_limit,h_60,w_90/v1681004095/vuhzrchiifjgdqss2bjo.jpg",

    title: "Typecasting in Python - Python Tutorial - Day #9",
    time: "7:23",
  },
];

export default data;
